import {Component, OnDestroy, OnInit, Input} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {L2Model} from '../../../../models/L2Model';
import {L3Model} from '../../../../models/L3Model';
import {SL5AnagrafService} from '../../../general-services/service-sl5-anagraf/sl5-anagraf.service';

@Component({
  selector: 'app-edit-l3-anagraf',
  templateUrl: './edit-sl5-anagraf.component.html',
  styleUrls: ['./edit-sl5-anagraf.component.scss']
})
export class EditSl5AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  l3: L3Model;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  saveSubscribe: Subscription;
  parameterSubscribe: Subscription;

  id: number;
  L3Cod: string;
  l3Json: any;
  description: any;
  submitted: boolean;


  constructor(private route: ActivatedRoute, private router: Router,
              private sl5AnagrafService: SL5AnagrafService, private _Activatedroute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.l3Json = params['row'];
      });

    this.l3 = new L2Model();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });

    this.l3 = JSON.parse(this.l3Json) as L3Model;

    this.formValidator.patchValue({
      cod: this.l3 ? this.l3.cod : ''
    });

    this.formValidator.patchValue({
      description: this.l3 ? this.l3.description : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.id = params['id'];
      this.L3Cod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL5_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.l3.cod = this.formValidator.controls['cod'].value;
      this.l3.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.sl5AnagrafService.update(this.sl5AnagrafService.baseUrl, this.l3).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, SL5 Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          }else {
            toastr.success('L3 with id ' + this.id + ' was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL5_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
